var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShow = function SvgShow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#606060",
    d: "M12 9a3.02 3.02 0 0 0-3 3c0 1.642 1.358 3 3 3 1.641 0 3-1.358 3-3 0-1.641-1.359-3-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#606060",
    d: "M12 5c-7.592 0-9.874 6.617-9.895 6.684L2 12l.104.316C2.126 12.383 4.408 19 12 19c7.592 0 9.874-6.617 9.895-6.684L22 12l-.104-.316C21.874 11.617 19.592 5 12 5zm0 12c-5.322 0-7.384-3.846-7.883-5 .5-1.158 2.564-5 7.883-5 5.322 0 7.384 3.846 7.883 5-.5 1.158-2.564 5-7.883 5z"
  })));
};
export default SvgShow;